import { gql } from "generated-graphql/gql";

export const TIER_II_REPORT_ASSOCIATIONS_QUERY = gql(`
  query AssociatedTierIIReports($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    tierIIReports(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
      items {
        id
        reportingYear
        reportKind
        createdAt
        encampStatus
        facility {
          id
          name
          streetAddress1
          city
          state
          zip
        }
        tenant {
          id
          name
        }
      }
    }
  }
`);

export const FACILITY_ASSOCIATIONS_QUERY = gql(`
  query AssociatedFacilities($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    facilities(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...FacilityPicker
        customerFacilityId
        streetAddress1
        streetAddress2
        city
        state
        zip
        tenant {
          id
          name
        }
      }
      count
    }
  }
`);

export const FACILITIES_BY_IDS_QUERY = gql(`
  query AssociatedFacilitiesByIds($ids: [ID!]!) {
    facilitiesByIds(ids: $ids) {
      ...FacilityPicker
      customerFacilityId
      streetAddress1
      streetAddress2
      city
      state
      zip
      tenant {
        id
        name
      }
    }
  }
`);

export const SUBMISSION_ASSOCIATIONS_QUERY = gql(`
  query AssociatedSubmissions($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    submissionVirtualEvents(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        taskId
        deadline
        title
        facilities {
          id
          name
        }
        submission {
          id
          title
          submissionType
          status
          dueDate
          tenantId
          staffAssignee {
            id
            email
            person {
              id
              first
              last
            }
          }
        }
      }
      count
    }
  }
`);

export const SUBMISSIONS_BY_IDS_QUERY = gql(`
  query AssociatedSubmissionsByIds($ids: [ID!]!) {
    submissionsByIds(ids: $ids) {
      id
      title
      submissionType
      status
      dueDate
      tenantId
      facilitySubmissions {
        id
        facility {
          id
          name
        }
      }
    }
  }
`);
